import {type ReactNode, type VFC} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import DeclineToQuote from '../components/PaymentSystemsRegulator/components/DeclineToQuote/index.js';
import SystemFailure from '../components/PaymentSystemsRegulator/components/SystemFailure/SystemFailure.js';
import CardPaymentServicesDetailsPage from '../containers/PaymentSystemsRegulator/CardPaymentServicesDetailsPage.js';
import {PaymentSystemsRegulatorLoadable} from '../containers/PaymentSystemsRegulator/Loadable.js';
import {ROUTE_PATHS} from '../utils/constants/public/psr.js';
import {ROUTES_PREFIX} from '../utils/constants/shared.js';

type Props = {
  children?: ReactNode;
};

const PublicRoutes: VFC<Props> = () => (
  <Switch>
    <Route
      component={PaymentSystemsRegulatorLoadable}
      path={ROUTE_PATHS.PAYMENT_SYSTEMS_REGULATOR_PATH}
    />
    <Route
      component={CardPaymentServicesDetailsPage}
      path={ROUTE_PATHS.PAYMENT_SYSTEMS_OUTPUT_PAGE_PATH}
    />
    <Route
      component={DeclineToQuote}
      path={ROUTE_PATHS.DECLINE_TO_QUOTE_PATH}
    />
    <Route component={SystemFailure} path={ROUTE_PATHS.SYSTEM_FAILURE_PATH} />
    <Redirect
      from={ROUTES_PREFIX.PUBLIC}
      to={ROUTE_PATHS.PAYMENT_SYSTEMS_REGULATOR_PATH}
    />
  </Switch>
);

export default PublicRoutes;
